const styles = {
  dateOfBirth: {
    width: '100%',
  },
  contanierGrid: {
    marginBottom: 2,
  },
};

export default styles;
